import { createFileRoute } from "@tanstack/react-router";

import { seo } from "@/lib/seo";
import { localBusinessSchema } from "@/lib/business";
import { getCaseStudies, getSiteStats, getTestimonials } from "@/lib/content";
import { Hero } from "@/components/home/Hero";
import { TrustBar } from "@/components/home/TrustBar";
import { ThreePaths } from "@/components/home/ThreePaths";
import { WhyDifferent } from "@/components/home/WhyDifferent";
import { ServicesGrid } from "@/components/home/ServicesGrid";
import { AiAdvantage } from "@/components/home/AiAdvantage";
import { Results } from "@/components/home/Results";
import { ScoreCta } from "@/components/home/ScoreCta";
import { Process } from "@/components/home/Process";
import { PricingTeaser } from "@/components/home/PricingTeaser";
import { Faq, faqPageSchema } from "@/components/home/Faq";
import { LocalPresence } from "@/components/home/LocalPresence";
import { FinalCta } from "@/components/home/FinalCta";

export const Route = createFileRoute("/_site/")({
  head: () =>
    seo({
      title: "AI Consulting for Small Businesses",
      description:
        "AI consulting for small businesses: we map how you operate, rank where AI actually pays, and build systems your team uses. Las Vegas, serving nationwide.",
      path: "/",
      jsonLd: [localBusinessSchema, faqPageSchema],
    }),
  loader: async () => {
    const [stats, caseStudies, testimonials] = await Promise.all([
      getSiteStats(),
      getCaseStudies({ data: { limit: 3 } }),
      getTestimonials({ data: { limit: 3 } }),
    ]);
    return { stats, caseStudies, testimonials };
  },
  component: Page,
  errorComponent: () => (
    <>
      <Hero />
      <TrustBar />
      <ThreePaths />
      <WhyDifferent />
      <ServicesGrid />
      <AiAdvantage />
      <ScoreCta />
      <Process />
      <PricingTeaser />
      <Faq />
      <LocalPresence />
      <FinalCta />
    </>
  ),
  notFoundComponent: () => null,
});

function Page() {
  const { stats, caseStudies, testimonials } = Route.useLoaderData();

  return (
    <>
      <Hero />
      <TrustBar stats={stats} />
      <ThreePaths />
      <WhyDifferent />
      <ServicesGrid />
      <AiAdvantage />
      <Results caseStudies={caseStudies} testimonials={testimonials} />
      <ScoreCta />
      <Process />
      <PricingTeaser />
      <Faq />
      <LocalPresence />
      <FinalCta />
    </>
  );
}
